<div *ngIf="!showNewUser">
  {{message | translate}}
</div>
<div *ngIf="showNewUser">
  <ap-invitations-new-user [data]="data"></ap-invitations-new-user>
</div>
